// base
import React from 'react';
import { useHistory } from 'react-router';

// styles
import { StyledNotFoundResult } from './style';

// routes
import { ROUTE_ROOT } from 'routes/const';

// libraries
import { Result, Button } from 'antd';

export const NotFoundResult = () => {
  const history = useHistory();

  return (
    <StyledNotFoundResult>
      <Result
        status="404"
        title="404 페이지를 찾을 수 없습니다."
        subTitle={
          <div style={{ margin: '12px 0' }}>
            페이지가 존재하지 않거나, 사용할 수 없는 페이지 입니다.
            <br />
            입력하신 주소가 정확한지 다시 한 번 확인해주세요.
          </div>
        }
        extra={
          <Button type="primary" onClick={() => history.push(ROUTE_ROOT)}>
            홈으로 돌아가기
          </Button>
        }
      />
    </StyledNotFoundResult>
  );
};
